import { useDrawer } from '@/components/common/DrawerManager';
import { FlexRow } from '@/components/common/Flex';
import { Text } from '@/components/common/Typography';
import { toDollars } from '@/util/currency';
import { AnyDepositoryAccount } from '@common/financialEntities';
import { useGoalsFundedByAccount } from '@common/react/financialEntities';
import { dt } from '@common/util/dateTime';
import { FC } from 'react';
import { EntityViewGridSection } from '../common/EntityView';
import { FlexCol } from '../common/Flex';
import { hoverStyleProps } from '../common/styleHelpers';
import GoalIconCircle from '../goals/GoalIconCircle';

export interface FinancialEntityDetailFundingSectionProps {
    fe: AnyDepositoryAccount;
}

const FinancialEntityDetailFundingSection: FC<
    FinancialEntityDetailFundingSectionProps
> = ({ fe }) => {
    const fundingGoals = useGoalsFundedByAccount(fe);
    const { showDrawer } = useDrawer();

    if (fundingGoals.length === 0) return <></>;

    return (
        <EntityViewGridSection
            title={`Funding ${fundingGoals.length} goals`}
            mb={12}
        >
            <FlexCol gap={3}>
                {fundingGoals.map(({ goal, transactionSchedules }) => {
                    // TODO: Decide how to handle multiple transaction schedules
                    // This shouldn't be an issue as long as partners are using
                    // different funding accounts.
                    if (transactionSchedules.length > 1) {
                        console.warn(
                            'Found multiple transaction schedules funding the same goal'
                        );
                    }
                    const transactionSchedule = transactionSchedules[0];
                    return (
                        <FlexCol
                            key={transactionSchedule.id}
                            borderWidth={1}
                            borderColor="border"
                            borderRadius={8}
                            boxShadow="0px 15px 45px -10px rgba(0, 0, 0, 0.05);"
                            mt={2}
                            p={6}
                            onClick={() =>
                                showDrawer({
                                    drawerKey: 'goal-detail',
                                    entityId: goal.id,
                                })
                            }
                            {...hoverStyleProps({ shadow: 'md' })}
                        >
                            <GoalIconCircle type={goal.type} mb={5} />
                            <Text fontWeight="semibold" pb={3}>
                                {goal.name}
                            </Text>
                            {transactionSchedule?.status === 'ACTIVE' && (
                                <>
                                    <FlexRow justifyContent="space-between">
                                        <Text pb={1}>Transfer scheduled</Text>
                                        <Text pb={1}>
                                            {toDollars(
                                                transactionSchedule.amount
                                            )}
                                        </Text>
                                    </FlexRow>
                                    <Text
                                        fontSize="sm"
                                        color="gray.500"
                                        pl={1}
                                        pb={2}
                                    >
                                        {dt(
                                            transactionSchedule.nextTransactionDate
                                        ).format('MMM DD, YYYY')}
                                    </Text>
                                </>
                            )}
                        </FlexCol>
                    );
                })}
            </FlexCol>
        </EntityViewGridSection>
    );
};

export default FinancialEntityDetailFundingSection;
